import ReducerRegistry from "seneca-common/utils/state/reducer-registry";

import { PATH_TO_CLASS_LEADERBOARDS_STATE } from "./consts";
import classLeaderboardsReducer from "./reducers";

const reducerRegistry = ReducerRegistry.getInstance();
reducerRegistry.initialise(PATH_TO_CLASS_LEADERBOARDS_STATE, builder => {
  builder.register(PATH_TO_CLASS_LEADERBOARDS_STATE, classLeaderboardsReducer);
});

export { receiveClassLeaderboard } from "./actions";

export { fetchClassLeaderboardActionFactory } from "./actions/meta";

export { getClassLeaderboardWhereRankImproved } from "./selectors";
